
import React, { useState } from 'react';
import { Fragment } from "react"
import './blogs.module.css'
import { Helmet } from 'react-helmet';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faComment, faArrowLeft} from '@fortawesome/pro-regular-svg-icons';
import AdminOverflow from './Admin/AdminOverflow';
import AddCommentButton from './Comments/AddCommentButton';
import Comments from './Comments';
import moment from 'moment';
import { isAdmin, isLoggedIn } from '../../utils/localStorage';
import { useRouteMatch } from 'react-router-dom';
import { locationString } from '../../utils';
import FlexFooter from '../Layout/FlexFooter';
import { useHistory } from 'react-router-dom';
import MapPinGrey from "../../images/Icons/map-pin-grey.svg"


const BlogPageContent = ({blog,refetch}) => {

    const match = useRouteMatch();
    const region = match.params.region;

    const history = useHistory();


    const [overflow,setOverflow] = useState(false);
    const [content,setContent] = useState("");

    const toggleOverflow = () => {setOverflow(!overflow)}

    const handleContentChange = (event) => {
        setContent(event.target.value);
      };
    
    const cleanHTML = (content) => {
        return content.replace(/<(\/?(script|noscript|iframe|link|embed|object|input|form|textarea|div)\b)[^>]*>/gi, '');
    }
    
    return(
        <Fragment>
            <Helmet>
                <title>Autzu | {blog.title}</title>
                <meta name="description" content={blog.content} />
            </Helmet>
            <div className='blogsPage container'>
                <div className='blogsContainer'>
                    <div className='allBlogsLink' onClick={()=>history.push('../blogs')}><FontAwesomeIcon icon={faArrowLeft}/> Back to all blogs</div>
                    <div className='blogLocation'><img src={MapPinGrey} className='mapIcon'/> {locationString(region)}</div>
                    <div className='blogTitle'>
                        <div className='blogTitleHeader'>
                            {blog.title}
                            {
                                isAdmin()?
                                <div className='overflowButton' onClick={toggleOverflow}>⋮</div>
                                :""
                            }
                        </div>
                        <div className='blogTitleFooter'>
                            {moment(blog.publicationDate).format("MMMM Do, YYYY")} · {blog.readTime} minute read · <FontAwesomeIcon icon={faComment}/> {blog.comments.length}
                        </div>
                        {
                            isAdmin()?
                            <div className='blogTitleFooter'>
                                Published: {moment(blog.publicationDate).format("HH:mm MM/DD/YYYY")} by {blog.publisher}
                            </div>
                            :""
                        }
                                                {
                            isAdmin() && blog.lastEditedBy !== null?
                            <div className='blogTitleFooter'>
                                Last Edited By: {moment(blog.lastEditedAt).format("HH:mm MM/DD/YYYY")} by {blog.lastEditedBy}
                            </div>
                            :""
                        }
                        
                        {overflow?<AdminOverflow id={blog.id} urlTitle={blog.urlTitle}/>:""}
                    </div>

                    <img src={blog.imageUrl} className='blogPicture'/>
                    <div className='blogBody' dangerouslySetInnerHTML={{__html:cleanHTML(blog.content)}}>
                    </div>

                    <div className='commentsTitle'> Comments </div>

                    {isLoggedIn()?
                        <textarea className='commentInput' placeholder='Add a comment...' value={content} onChange={handleContentChange}/>
                        :<div className='commentInputBlocked'> Add a comment...
                        <div className='commentLoginPrompt'>Login to comment</div>
                        <div className='commentLoginButton' onClick={()=>history.push("../../login", {destination: window.location.pathname})}>Login</div>
                        </div>
                        }
                    {isLoggedIn()?
                        <AddCommentButton blogId={blog.id} content={content} refetchBlog={refetch} setContent={setContent}/>
                        :
                        <div className='addCommentButtonFaded'>
                            + Add comment
                        </div>
                    }

                    <Comments comments={blog.comments} refetch={refetch}/>

                </div>
            <FlexFooter region={region}/>
            </div>
        </Fragment>
    )
}

export default BlogPageContent;


// WEBPACK FOOTER //
// ./src/components/Blogs/BlogPageContent.js